<button type="text" title="{{'fs.res.publication.citation' | hisUi}}" (click)="display=true" hisImage="citation" 
						class="transparent"><span>{{'fs.res.publication.citation' | hisUi}}</span></button>
<p-dialog [(visible)]="display" [responsive]="true"  [modal]="true" [dismissableMask]="true" [blockScroll]="true">
    <p-header><h2>{{ 'fs.res.publication.citation' | hisUi }}</h2></p-header>

	<a (click)="navigateToBibtexFile(publication.id)" (keypress)="navigateToBibtexFile(publication.id)" tabindex="0" hisImage="BIBTEX" class="transparent">{{'fs.res.common.bibtex' | hisUi}}</a>
<!--     <a href="https://doi.org/10.15488/4279" hisImage="bullet_his_blue" class="transparent">BibTeX</a>
	<a href="https://doi.org/10.15488/4279" hisImage="bullet_his_blue" class="transparent">RIS</a> -->
	<div class="detailPresentationList citation">
		<div class="layoutBlock detailPresentationListItem">
			<ng-container *ngFor="let item of citations">
				  <ng-container  *ngIf="item; then showitem; else dontshowitem">
				  </ng-container>
				  
				  <ng-template #showitem>
				         <div class="columnDetailLabel detailPresentationListLabel" ><span >{{'fs.res.publication.citation.' + item[0] | hisUi}}</span></div>
				         <div class="columnDetailContent detailPresentationListContent" [innerHTML]="item[1]"></div>
				  </ng-template>
				  
				  <ng-template #dontshowitem>
				     <div></div>
				  </ng-template>
	        </ng-container>
		</div>
	</div>
    <p-footer>
       	<button type="button" title="{{'fs.res.publication.citation.close' | hisUi}}" 
       				(click)="display=false"><span>{{'fs.res.publication.citation.close' | hisUi}}</span></button>
    </p-footer>
</p-dialog>
